import { render, staticRenderFns } from "./workerWageJobTitle.vue?vue&type=template&id=89d86278&"
import script from "./workerWageJobTitle.vue?vue&type=script&lang=js&"
export * from "./workerWageJobTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports